import type { BotFlowElegivel, BotFlowsElegiveisQuery } from '../types';

export function botFlowElegivelLabel(bot: BotFlowElegivel): string {
  return `${bot.agentNome} · agente interno`;
}

export function botFlowsElegiveisQueryKey(query: BotFlowsElegiveisQuery): string {
  return JSON.stringify([query.page, query.limit, query.search ?? '', query.ids ?? []]);
}
